import { Injectable, inject } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardChild implements CanActivateChild {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.hasValidSession()) {
      const currentUser = this.authenticationService.currentUserValue;
      const { roles } = route.data;
      if (roles && !(currentUser && roles.includes(currentUser.user.role))) {
        this.router.navigate(['/unauthorized']);
        return false;
      }
      return true;
    }
    const t = sessionStorage.getItem('auth_token');
    if (t) {
      try {
        const p = JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        console.log('[GUARD] exp - now =', p.exp - Date.now() / 1000, 's', '| exp =', p.exp, '| now =', Math.floor(Date.now() / 1000));
      } catch (e) {
        console.log('[GUARD] token illisible', e);
      }
    } else {
      console.log('[GUARD] aucun token dans sessionStorage');
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
